import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { sendPackageOperationalEvent } from '../../../common/utils';
import { isProcessingAllowedByPreferences } from '../../../common/utils/item-processing';
import { Logger } from '../../../common/utils/logger';
import { BSCIndexedDB } from '../../../services/indexed-db-service';
import { CategoryStorageType, Status } from '../../../types';
import { WebStorageType } from '../types';

// SET COOKIE ANALOGUE
/**
 * Sets a WebStorage item asynchronously. This queries user preferences before setting
 * the item, so it must be used for any items which are not strictly necessary.
 */
export var setStorageItem = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(itemKey, value, storageType, productName, browserStorage) {
    var shouldSetItem, eventAttributes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return isProcessingAllowedByPreferences({
            itemKey: itemKey,
            storageType: storageType === WebStorageType.LocalStorage ? CategoryStorageType.LocalStorage : CategoryStorageType.SessionStorage,
            productName: productName
          });
        case 2:
          shouldSetItem = _context.sent;
          eventAttributes = {
            wasRejected: !shouldSetItem,
            itemKey: itemKey,
            storageType: storageType
          };
          _context.prev = 4;
          sendPackageOperationalEvent({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
          });
          if (!shouldSetItem) {
            _context.next = 13;
            break;
          }
          _context.next = 9;
          return BSCIndexedDB.setRecord(itemKey);
        case 9:
          browserStorage.setItem(itemKey, value);
          return _context.abrupt("return", Status.SUCCESS);
        case 13:
          return _context.abrupt("return", Status.BLOCKED);
        case 14:
          _context.next = 20;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](4);
          Logger.errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: "Failed to set ".concat(storageType, " item. ").concat(_context.t0.message || '')
          });
          return _context.abrupt("return", Status.BLOCKED);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 16]]);
  }));
  return function setStorageItem(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();